module.exports = __webpack_public_path__ + "static/addproject-c8a9b6f3b640d382c3404244c74fdb85.png";